import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faArrowsV,
  faBold,
  faBookSpells,
  faBookmark,
  faBorderAll,
  faBrackets,
  faBullseye,
  faCaretCircleDown,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardListCheck,
  faClock,
  faCrown,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faFile,
  faFileAlt,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileSpreadsheet,
  faFileWord,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faFolders,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHdd,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faLock,
  faMagic,
  faMicrophone,
  faMicroscope,
  faNetworkWired,
  faOutdent,
  faPaintBrush,
  faPaperPlane,
  faPen,
  faPercent,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPuzzlePiece,
  faSignature,
  faSort,
  faStars,
  faStickyNote,
  faStop,
  faStopwatch,
  faTags,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTimesOctagon,
  faUnderline,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUsersCog,
  faUsersCrown,
  faVideo,
  faVideoPlus,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faArrowUp,
  faArrowsV,
  faBold,
  faBookSpells,
  faBookmark,
  faBorderAll,
  faBrackets,
  faBullseye,
  faCaretCircleDown,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardListCheck,
  faClock,
  faCrown,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faFile,
  faFileAlt,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileSpreadsheet,
  faFileWord,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faFolders,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHdd,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faLock,
  faMagic,
  faMicrophone,
  faMicroscope,
  faNetworkWired,
  faOutdent,
  faPaintBrush,
  faPaperPlane,
  faPen,
  faPercent,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPuzzlePiece,
  faSignature,
  faSort,
  faStars,
  faStickyNote,
  faStop,
  faStopwatch,
  faTags,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTimesOctagon,
  faUnderline,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUsersCog,
  faUsersCrown,
  faVideo,
  faVideoPlus,
);



// WEBPACK FOOTER //
// ./src/fontawesome/solid.js